/**
 * Parwaaz backend — error types used by the core.
 * Each carries the ApiErrorCode the dispatcher in handlers.ts maps it to.
 * (NotFoundError, ConflictError, BusyError live in store.ts — this file adds the rest.)
 */
import type { ApiErrorCode } from '@parwaaz/shared';

export class ValidationError extends Error {
  code: ApiErrorCode = 'bad_request';
  constructor(message: string) {
    super(message);
    this.name = 'ValidationError';
  }
}

export class ForbiddenError extends Error {
  code: ApiErrorCode = 'forbidden';
  constructor(message = 'not permitted') {
    super(message);
    this.name = 'ForbiddenError';
  }
}

export class UnauthorizedError extends Error {
  code: ApiErrorCode = 'unauthorized';
  constructor(message = 'sign in required') {
    super(message);
    this.name = 'UnauthorizedError';
  }
}

export class IllegalTransitionError extends Error {
  code: ApiErrorCode = 'illegal_transition';
  constructor(message: string) {
    super(message);
    this.name = 'IllegalTransitionError';
  }
}

export class RateLimitedError extends Error {
  code: ApiErrorCode = 'rate_limited';
  constructor(message = 'too many attempts, try again later') {
    super(message);
    this.name = 'RateLimitedError';
  }
}
